const def = " - Holiday Inn";

export default {
  name: "holiday-inn",
  tags: ["Lobby" + def, "Bar" + def, "Entrance" + def, "Meeting Space" + def]
};
